// <s-countdown> — ticks down to data-end (epoch ms) once per second.
// Writes "Xd HHh MMm SSs" into [data-countdown-value]; hides itself when finished if data-hide-when-finished is set.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const end = Number(this.dataset.end);
    const value = this.querySelector("[data-countdown-value]");
    if (!end || !value) return;

    const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const pad = (n) => String(n).padStart(2, "0");
    const d = Math.floor(remaining / 86400);
    const h = Math.floor((remaining % 86400) / 3600);
    const m = Math.floor((remaining % 3600) / 60);
    const s = remaining % 60;
    const u = this.dataset;
    value.textContent = `${d}${u.unitD} ${pad(h)}${u.unitH} ${pad(m)}${u.unitM} ${pad(s)}${u.unitS}`;

    if (remaining === 0) {
      clearInterval(this.#timer);
      if (this.hasAttribute("data-hide-when-finished")) this.hidden = true;
    }
  }
}

if (!customElements.get("s-countdown")) {
  customElements.define("s-countdown", SCountdown);
}
